import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, } from "react";
const sizes = { sm: 12, base: 14, lg: 20, xl: 28 };
const colors = {
    // Leave color unset so parent-owned states and raw color classes still apply.
    inherit: undefined,
    default: "hsl(var(--icon-foreground))",
    foreground: "hsl(var(--foreground))",
    muted: "hsl(var(--muted-foreground))",
    secondary: "hsl(var(--foreground-secondary))",
    tertiary: "hsl(var(--foreground-tertiary))",
    destructive: "hsl(var(--destructive))",
};
export function createIcon(Component, displayName, strokeWidth) {
    const Icon = forwardRef(function Icon({ size = "base", color = "inherit", __rawClassName, __rawStyle, className: _className, style: _style, width: _width, height: _height, strokeWidth: _strokeWidth, ...props }, ref) {
        return (_jsx(Component, { ...props, ref: ref, size: sizes[size], width: sizes[size], height: sizes[size], strokeWidth: strokeWidth, className: __rawClassName, style: { flexShrink: 0, color: colors[color], ...__rawStyle } }));
    });
    Icon.displayName = displayName;
    return Icon;
}
